export const siteSettings = {
  name: "Market Stack Hub",
  link: "https://marketstackhub.com",
  email: "support@marketstackhub.com",
  appLink: "https://app.marketstackhub.com",
};
